import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLike, meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {FilterOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/filter-operator/geometry-filter-operator-node"
import {
    GeometryFilterOperatorNode,
    filterOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/filter-operator/geometry-filter-operator-node"

export type MeshGeometryFilterOperatorParameters = FilterOperatorParameters<MeshGeometryAttributeLikeNode, MeshGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryFilterOperatorParameters> = {
    nodeClass: "MeshGeometryFilterOperator",
    validation: {
        parameters: filterOperatorParametersSchema(meshGeometryAttributeLike, meshGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryFilterOperator
    extends GeometryFilterOperatorNode<2, MeshGeometryAttributeLikeNode, MeshGeometryAttributeSetLikeNode>
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
